import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { InsuranceSubmitListPage } from './InsuranceSubmitListPage';

export function InsuranceSubmitPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        exact
        element={<InsuranceSubmitListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

InsuranceSubmitPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
